import * as Sentry from '@sentry/react';

import analytics from 'utils/analytics';
import isDevelopment from 'utils/isDevelopment';

const IGNORE_ERRORS = [];
const DENY_URLS = [];

class SentryManager {
  constructor(projectName = 'internal') {
    this.endpoint = process.env.REACT_APP_SENTRY_DSN_URL;
    this.forceLogOnSentryDashboard = false;
    this.projectName = projectName;
    this.status = 'disabled';
  }

  async enableCapture() {
    if (isDevelopment() && !this.forceLogOnSentryDashboard) return;

    const integrations = [Sentry.browserTracingIntegration()];

    Sentry.init({
      dsn: this.endpoint,
      environment: process.env.REACT_APP_ENV,
      ignoreErrors: IGNORE_ERRORS,
      denyUrls: DENY_URLS,
      normalizeDepth: 200,
      tracesSampleRate: 0.3,
      integrations,
    });

    Sentry.setUser({
      email: analytics?.superAttributes?.user_email || 'impact@getshitdone.com',
    });
    this.status = 'enabled';
  }

  async close(callback = () => {}) {
    await Sentry.close();
    this.status = 'disabled';
    callback();
  }

  enableProfiler = (reactComponent, appName) => {
    if (isDevelopment() && !this.forceLogOnSentryDashboard) {
      return reactComponent;
    }

    return Sentry.withProfiler(reactComponent, { name: appName });
  };

  reduxUnhandledErrorReporter = (store) => (next) => (action) => {
    try {
      return next(action);
    } catch (err) {
      if (isDevelopment() && !this.forceLogOnSentryDashboard) {
        throw err;
      } else {
        Sentry.captureException(err, {
          extra: { action, state: store.getState() },
        });
      }
    }
    return null;
  };

  enableRedux = () => Sentry.createReduxEnhancer();

  captureException = (error) => {
    if (isDevelopment() && !this.forceLogOnSentryDashboard) {
      throw error;
    }
    return Sentry.captureException(error);
  };

  captureMessage = (message) => {
    if (isDevelopment() && !this.forceLogOnSentryDashboard) {
      console.log(message);
      return;
    }

    return Sentry.captureMessage(message);
  };

  _createEndpoint = (projectName) => {
    return this.endpoint;
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new SentryManager();
